import { useQuery } from '@tanstack/react-query';

import { getSkillCategories } from '../services/api/skill-category';

export function useSkillCategory() {
  return useQuery({
    queryKey: ['skillCategories'],
    queryFn: async () => {
      const data = await getSkillCategories();
      return data;
    },
  });
}
